module.exports = lincd._modules['lincd_ads'];